










import Vue from "vue";
export default Vue.extend({
  name: "DefinitionField",
  props: {
    label: {
      type: String,
      default: "",
    },
    highlight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rowClass() {
      return this.highlight ? "highlighted" : "";
    },
  },
});
